export default __webpack_public_path__ + "static/media/offer-reward.7a436c17.svg";